import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

import en from './en.json';
import cn from './zh-CN.json';
import de from './de.json';

export const messages = {
    en,
    cn,
    de,
};

export const supportedLanguages = Object.keys(messages);
export const fallbackLocale = 'en';

export const __LOCAL_STORAGE_LANGUAGE_KEY__ = 'local_storage_lang';

function getUserLanguage() {
    let cachedLanguage = localStorage.getItem(__LOCAL_STORAGE_LANGUAGE_KEY__);

    if (cachedLanguage && cachedLanguage === 'zh') {
        cachedLanguage = 'cn'; // Fallback for users who had selected zh previously
    } else if (cachedLanguage && !supportedLanguages.includes(cachedLanguage)) {
        cachedLanguage = null;
    }

    if (!cachedLanguage) {
        // Get the language of the browser and only take the first part e.g. en-GB will be en
        const browserLang = navigator.language.split('-')[0];
        if (browserLang in messages) {
            cachedLanguage = browserLang;
        } else {
            cachedLanguage = fallbackLocale;
        }
        localStorage.setItem(__LOCAL_STORAGE_LANGUAGE_KEY__, cachedLanguage);
    }
    return cachedLanguage;
}

export function changeLanguage(language) {
    if (supportedLanguages.includes(language)) {
        i18n.locale = language;
        localStorage.setItem(__LOCAL_STORAGE_LANGUAGE_KEY__, language);
    } else {
        throw new Error(`Cannot change to unsupported language ${language}`);
    }
}

export const i18n = new VueI18n({
    locale: getUserLanguage(),
    fallbackLocale,
    messages,
});

export default i18n;
